import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useBrowserStore } from '@apps/main/new-desktop/core/stores/browserStore';

import type {
  ActivityDetailsData,
  ActivityDetailsHeaderData,
  GalleryType,
} from '../models';

import {
  getActivityDetailsHeaderData,
  getGalleryType,
} from './activityDetailsStoreLogic';

export const useActivityDetailsStore = defineStore(
  'ActivityDetailsStore',
  () => {
    const browserStore = useBrowserStore();

    // State
    const activityDetails = ref<ActivityDetailsData | undefined>();

    // Actions
    function setActivityDetails(
      initialActivityDetails: ActivityDetailsData
    ): void {
      activityDetails.value = initialActivityDetails;
    }

    // Getters
    const headerData = computed<ActivityDetailsHeaderData | undefined>(() =>
      getActivityDetailsHeaderData(activityDetails.value)
    );

    const galleryType = computed<GalleryType>(() =>
      getGalleryType(browserStore.isSmallerThan1200px)
    );

    return {
      // State
      activityDetails,

      // Actions
      setActivityDetails,

      // Getters
      galleryType,
      headerData,
    };
  }
);
